import {
  DOTA_2_SETTINGS,
  getDota2Statistics
} from 'utils/constants/moba-games/dota-2';
import {
  getLeagueOfLegendsStatistics,
  LEAGUE_OF_LEGENDS_SETTINGS
} from 'utils/constants/moba-games/league-of-legends';
import { GameInfoAdditionalDataMap } from 'interfaces/sportsbook-data-levels';

const COUNTER_STRIKE_ID = 75;
const LEAGUE_OF_LEGENDS_ID = 77;
const DOTA_2_ID = 76;

export const ESPORTS_ADDITIONAL_DATA_IDS = [
  COUNTER_STRIKE_ID,
  LEAGUE_OF_LEGENDS_ID,
  DOTA_2_ID
];

export const STREAMING_ASPECT_RATIOS = {
  desktop: 20,
  mobile: 26
};

export interface T_ESPORTS_ADDITIONAL_DATA {
  id: number;
  name: 'mapName';
  current: 'currentMap' | 'currentRound';
  number: 'mapNumber' | 'roundNumber';
  maps: 'maps' | 'rounds';
  alias: string;
  outcome: 'roundsOutcome' | 'killScore';
}

type T_GET_MOBA_GAMES_SETTINGS_DATA = {
  [key: string]: {
    titles: { [key: number]: string | null };
    icons: {
      names: { [key: number]: string | null };
      firstSanctuary: { [key: number]: string };
      secondSanctuary: { [key: number]: string };
      positions: {
        [key: string]: {
          [key: string | number]: string | { [key: string]: string };
        };
      };
      getIconPositionsAndSizes: (width: number) => {
        [key: string]: {
          position: any;
          size: { width: number; height: number };
        };
      };
    };
  };
};

type T_GET_MOBA_GAMES_STATISTICS_DATA = {
  [key: string]: (additionalDataMap: GameInfoAdditionalDataMap | undefined) => {
    statistics: {
      1: { [key: number]: number | null };
      2: { [key: number]: number | null };
    };
    mapState: { [key: number]: any };
  };
};

export const ESPORTS_ADDITIONAL_DATA: {
  [key: string]: T_ESPORTS_ADDITIONAL_DATA;
} = {
  CounterStrike: {
    id: ESPORTS_ADDITIONAL_DATA_IDS[0],
    name: 'mapName',
    current: 'currentMap',
    number: 'mapNumber',
    maps: 'maps',
    alias: 'CounterStrike',
    outcome: 'roundsOutcome'
  },
  LeagueOfLegends: {
    id: ESPORTS_ADDITIONAL_DATA_IDS[1],
    name: 'mapName',
    current: 'currentRound',
    number: 'roundNumber',
    maps: 'rounds',
    alias: 'LeagueOfLegends',
    outcome: 'killScore'
  },
  Dota2: {
    id: ESPORTS_ADDITIONAL_DATA_IDS[2],
    name: 'mapName',
    current: 'currentRound',
    number: 'roundNumber',
    maps: 'rounds',
    alias: 'Dota2',
    outcome: 'killScore'
  }
};

export const GET_MOBA_GAMES_SETTINGS_DATA: T_GET_MOBA_GAMES_SETTINGS_DATA = {
  [ESPORTS_ADDITIONAL_DATA.LeagueOfLegends.alias]: LEAGUE_OF_LEGENDS_SETTINGS,
  [ESPORTS_ADDITIONAL_DATA.Dota2.alias]: DOTA_2_SETTINGS
};

export const GET_MOBA_GAMES_STATISTICS_DATA: T_GET_MOBA_GAMES_STATISTICS_DATA =
  {
    [ESPORTS_ADDITIONAL_DATA.LeagueOfLegends.alias]:
      getLeagueOfLegendsStatistics,
    [ESPORTS_ADDITIONAL_DATA.Dota2.alias]: getDota2Statistics
  };

export const isESportMOBAGames = (sportAlias: string) =>
  [
    ESPORTS_ADDITIONAL_DATA.LeagueOfLegends.alias,
    ESPORTS_ADDITIONAL_DATA.Dota2.alias
  ].includes(sportAlias);
